import { gql } from '@grandvisionhq/graphql';

const bookAppointmentTypeById = gql`
  fragment BookAppointmentStoreAppointmentTypeById on StoreAppointmentType {
    id
    name
    description
    duration {
      amount
      unit
    }
    price {
      amount
      currency
    }
    isAvailableInStore
    ageGroup
    tryInStore
    groupId
    visibleToCustomers
  }
`;
const bookAppointmentStoreById = gql`
  fragment BookAppointmentStoreById on Store {
    code
    globalStoreId
    name
    shortName
    streetName
    streetNumber
    additionalStreetInfo
    postalCode
    town
    province
    country
    lat
    lon
    email
    phone
    slug
    appointmentsAvailable
    appointmentTypes {
      ...BookAppointmentStoreAppointmentTypeById
    }
    servicesNotAvailable
  }
  ${bookAppointmentTypeById}
`;
const GET_BOOK_APPOINTMENT_STORE_BY_ID = gql`
  query GetBookAppointmentStoreById(
    $globalStoreId: ID
    $deviceGeoLocation: GeoLocationInput
    $slug: String
  ) {
    store(globalStoreId: $globalStoreId, deviceGeoLocation: $deviceGeoLocation, slug: $slug) {
      ...BookAppointmentStoreById
    }
  }
  ${bookAppointmentStoreById}
`;

export { GET_BOOK_APPOINTMENT_STORE_BY_ID };
//# sourceMappingURL=get-book-appointment-store-by-id.js.map
